import { useCallback, useEffect } from 'react';

interface UseThrottleArgs {
  lastFetchTime: number;
  staleTime: number;
  callback: () => void;
}

export const useThrottle = (
  { lastFetchTime, staleTime, callback }: UseThrottleArgs,
  dependencies: Array<any>
) => {
  const shouldRefetch = useCallback(() => {
    if (!lastFetchTime || staleTime === 0) return true;
    const currentTime = new Date().getTime();
    return currentTime - lastFetchTime >= staleTime;
  }, [lastFetchTime, staleTime]);

  useEffect(() => {
    if (shouldRefetch()) {
      callback();
    }
  }, [...dependencies, shouldRefetch]);
};
